import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Navigator } from 'src/app/components/menu/navigator';

@Component({
  selector: 'app-inactivity'
})
export class InactivityComponent implements OnInit {

  public timedOut: boolean = false;
  public idleTime: number;
  public timeOutTime: number;    

  constructor(
    private eventService: EventsService,
    private configService: ConfigService,
    private navigator: Navigator,
    private idle: Idle,
  ) { }

  ngOnInit() {
        
    this.eventService.subscribe("event:inactivity:reset", () => {
        this.resetTimeOut();
    });


    this.eventService.subscribe("event:mygames:highlight", () => {
        this.resetTimeOut();
    });

    this.eventService.subscribe("event:inactivity:start", () => {
      this.timeOutSet();
      this.resetTimeOut();
    })

    this.idleTime = Number(this.configService.getConfig().INACTIVITY_IDLE_TIME) || 900;
    this.timeOutTime = Number(this.configService.getConfig().INACTIVITY_TIMEOUT) || 15;
}

  resetTimeOut() {
      console.log('---Inactivity Started---')
      this.idle.stop();
      this.idle.watch();
      this.timedOut = false;
  }

  timeOutSet() {
    console.log('---Inactivity Started 2---')
      this.idle.setIdle(this.idleTime); //starts if user is idle for a certain number of seconds
      this.idle.setTimeout(this.timeOutTime); //if user doesn't respond, he/she will be timed out and logged out

      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    
      this.idle.onTimeout.subscribe(() => {
          this.timedOut = true;
          this.onTimeout();
      });
    

      this.idle.onTimeoutWarning.subscribe((countdown) => {
          console.log('You will time out in ' + countdown + ' seconds!');
      });
  }

  clearIdleObserversArray() {
      this.idle.stop();
      this.idle.onTimeout.observers.length = 0;
      this.idle.onIdleEnd.observers.length = 0;
      this.idle.onIdleStart.observers.length = 0;
      this.idle.onTimeoutWarning.observers.length = 0;
      this.idle.onIdleEnd.observers.length = 0;
  } 

  onTimeout() {
      this.clearIdleObserversArray();
      this.eventService.publish('event:game:close');
      this.eventService.publish("event:bottomfooter:show");
      this.navigator.toLobby();
  }     

}
